import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import ImageQuickLookManager from '@src/slide/infrastructure/module/dependent/image/image-toolkit/image-quick-look-manager';
import ImageUrl from '@src/slide/infrastructure/module/dependent/image/image-toolkit/image-url';
import { getAidForReport, POSITIONS } from '@tencent/txdocs-aid';
import { getOcrPureTextExtension } from '@src/js/common/ark-extensions/dc-components/ocr-pure-text';
import { IOcrService, IOcrServiceDelegates } from '../ocr-service.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';

export class OcrService implements IOcrService {
    private eventListenMap: Map<string, boolean>;
    private services: IOcrServiceDelegates;

    public constructor() {
        this.eventListenMap = new Map();
    }

    public setServiceDelegates(services: Partial<IOcrServiceDelegates>) {
        this.services = {
            ...this.services,
            ...services,
        };
    }

    public async showOcrRightBar(model: IPictureModel | IShapeModel, src?: string, obj?: any) {
        const ocrExtension = await getOcrPureTextExtension();
        const aid = getAidForReport({
            feature: 'slideocr',
            position: obj ? POSITIONS.PICRIGHTMENU : POSITIONS.PICTOOLBAR,
        });
        let ocrUrl = src || (model as IPictureModel).props.src
            || model.props.style.fillBackground?.image?.src as string;
        const { key } = model;
        if (ImageUrl.isBlobUrl(ocrUrl)) {
            const ImageResource = ImageQuickLookManager.getInstance().getResourceByUrl(ocrUrl);
            const cdnUrl = ImageResource?.getCdnUrl();
            if (cdnUrl) {
                ocrUrl = cdnUrl;
            } else {
                if (this.eventListenMap.get(key)) {
                    return;
                }
                this.eventListenMap.set(key, true);
                ImageResource?.onDidUpload((imageResource) => {
                    this.eventListenMap.delete(key);
                    this.showOcrRightBar(model, obj, imageResource.getCdnUrl());
                });
                return;
            }
        }
        this.services.ocrSideBarManager.show();
        const container = document.getElementById('rs-bar-ocr-sidebar');
        const tdwParams = { ver5: 'slide', ver6: obj ? 2 : 1 }; // 浮动工具栏入口1; 图片右键入口2;
        ocrExtension.show({
            container,
            source: aid,
            imageUrls: [ocrUrl],
            tdwParams,
            onClose: this.services.ocrSideBarManager.hide,
        });
        tdw({
            opername: TDWOperationType.OCR,
            module: TDWModuleType.OCR_PICTURE,
            action: TDWActionType.OCR_ENTRANCE,
            ver5: obj ? 1 : 0,
        });
        // 新产品riki统一新增的入口点击上报点，上面的暂时不清楚是否还需要暂时不动，carlson之后评估下旧上报是否可以删除
        tdw({
            opername: TDWOperationType.OCR_COMPONENTS,
            module: TDWModuleType.EXTRACT_TEXT,
            action: TDWActionType.OCR_ENTRANCE,
            ...tdwParams,
        });
    }
}
